export default __webpack_public_path__ + "static/media/kuriawan.17299f8f.jpg";